import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MassCommunicationComponent } from './mass-communication.component';

const routes: Routes = [
  { path: '', component: MassCommunicationComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MassCommunicationRoutingModule { }
